export interface DetailedService {
  id: string;
  name: string;
  price: string;
  duration: string;
  description: string;
  includes: string[];
  imageSeq: number;
  tag: string;
}

export const detailedServices: DetailedService[] = [
  {
    id: 'starter',
    name: 'Smile Starter',
    price: '99€',
    duration: '30 Minuten',
    description: 'Der perfekte Einstieg in die Welt der kosmetischen Zahnaufhellung. Ideal für besondere Anlässe oder als erste Erfahrung mit professioneller Aufhellung. Sichtbares Ergebnis bereits nach einer Sitzung.',
    includes: [
      'Persönliches Beratungsgespräch',
      'PAP-Aufhellungsgel (1 Durchgang)',
      'LED-Aktivierung (1x)',
      'Farbmessung vorher / nachher',
    ],
    imageSeq: 201,
    tag: 'Einstieg',
  },
  {
    id: 'classic',
    name: 'Smile Classic',
    price: '149€',
    duration: '45 Minuten',
    description: 'Unsere meistgebuchte Anwendung für langanhaltend strahlende Zähne. Zwei Aufhellungsdurchgänge für ein intensiveres Ergebnis — perfekt für alle, die wirklich einen Unterschied sehen wollen.',
    includes: [
      'Persönliches Beratungsgespräch',
      'PAP-Aufhellungsgel (2 Durchgänge)',
      'LED-Aktivierung (2x)',
      'Farbmessung vorher / nachher',
      'Zahnpflege-Tipps für zuhause',
    ],
    imageSeq: 202,
    tag: 'Bestseller',
  },
  {
    id: 'premium',
    name: 'Smile Premium',
    price: '199€',
    duration: '60 Minuten',
    description: 'Die Königsdisziplin für maximale Aufhellung und strahlende Zähne. Drei intensive Durchgänge, ein hochwertiges Nachsorge-Set und eine individuelle Empfehlung für die weitere Zahnpflege.',
    includes: [
      'Persönliches Beratungsgespräch',
      'PAP-Aufhellungsgel (3 Durchgänge)',
      'LED-Aktivierung (3x)',
      'Farbmessung vorher / nachher',
      'Exklusives Nachsorge-Set',
      'Individuelle Pflegeberatung',
    ],
    imageSeq: 203,
    tag: 'Premium',
  },
  {
    id: 'freshup',
    name: 'Fresh-Up',
    price: '69€',
    duration: '20 Minuten',
    description: 'Halte dein Ergebnis frisch! Der schnelle Auffrischungs-Boost für Bestandskunden — ideal alle 8–12 Wochen, um die Helligkeit zu erhalten und weiterzusteigern.',
    includes: [
      'PAP-Aufhellungsgel (1 Durchgang)',
      'LED-Aktivierung (1x)',
      'Nur für Bestandskunden',
    ],
    imageSeq: 204,
    tag: 'Auffrischung',
  },
  {
    id: 'homekit',
    name: 'Aufhellungs-Set für Zuhause',
    price: '49€',
    duration: 'Für zuhause',
    description: 'Dein persönliches Aufhellungs-Kit für unterwegs oder zuhause. Mit professionellem PAP-Gel und individueller Anleitung — als Ergänzung oder Zwischenpflege zu deiner Studio-Anwendung.',
    includes: [
      'PAP-Aufhellungs-Gel (4 Anwendungen)',
      'LED-Aktivator-Schiene',
      'Schritt-für-Schritt-Anleitung',
      'Desensibilisierungs-Serum',
    ],
    imageSeq: 205,
    tag: 'Take-Home',
  },
  {
    id: 'zahnschmuck',
    name: 'Zahnschmuck',
    price: 'ab 25€',
    duration: '15 Minuten',
    description: 'Kleines Extra mit großer Wirkung! Kristall- oder Goldapplikationen auf dem Zahn — schmerz- und bohrlochfrei aufgebracht. Nach Belieben wieder entfernbar.',
    includes: [
      'Auswahl aus verschiedenen Designs',
      'Schmerzfreie Applikation',
      'Hält 2–4 Monate',
      'Optional kombinierbar mit Aufhellung',
    ],
    imageSeq: 206,
    tag: 'Extra',
  },
];

export interface ComparisonFeature {
  feature: string;
  starter: boolean | string;
  classic: boolean | string;
  premium: boolean | string;
}

export const comparisonFeatures: ComparisonFeature[] = [
  { feature: 'Beratungsgespräch', starter: true, classic: true, premium: true },
  { feature: 'Farbmessung vorher / nachher', starter: true, classic: true, premium: true },
  { feature: 'PAP-Aufhellungsdurchgänge', starter: '1x', classic: '2x', premium: '3x' },
  { feature: 'LED-Aktivierung', starter: '1x', classic: '2x', premium: '3x' },
  { feature: 'Zahnpflege-Tipps', starter: false, classic: true, premium: true },
  { feature: 'Nachsorge-Set', starter: false, classic: false, premium: true },
  { feature: 'Individuelle Pflegeberatung', starter: false, classic: false, premium: true },
  { feature: 'Peroxidfrei (PAP)', starter: true, classic: true, premium: true },
  { feature: 'Dauer', starter: '30 Min.', classic: '45 Min.', premium: '60 Min.' },
  { feature: 'Preis', starter: '99€', classic: '149€', premium: '199€' },
];
